import type { RunFilters } from '@/pages/runs/run-filters';

export interface RunEventsKeyParams {
  page: number;
  level: string | null;
  outcome: string | null;
  code: string | null;
}

export const syncKeys = {
  all: ['sync'] as const,

  jobs: () => [...syncKeys.all, 'jobs'] as const,
  /** The preset's name is in the key, not the clock: the dates are worked out when it fetches. */
  runHistory: (filters: Omit<RunFilters, 'hideQuiet'>, pageSize: number) =>
    [...syncKeys.all, 'run-history', filters, pageSize] as const,
  run: (id: string, params: RunEventsKeyParams) => [...syncKeys.all, 'run', id, params] as const,
  runCodes: (id: string) => [...syncKeys.all, 'run-codes', id] as const,
  conflicts: () => [...syncKeys.all, 'conflicts'] as const,
};
